<template>
    <auth-background-styled>
        <div class="bg" />
        <div class="auth-row">
            <div class="auth-column static-effect">
                <div class="auth-top-logo">
                    <header-logo isWhite />
                </div>
                <st-divider>우리 아이보다 먼저</st-divider>
                <st-divider :between="1.8">도착하는 <b>학교 소식</b></st-divider>
                <st-divider>
                    <st-button size="large" color="ghost" :width="21" link :path="path.android" target="_blank">
                        <awesome-icon preset="fab" name="google-play" />
                        플레이스토어(Android)
                    </st-button>

                    <st-button size="large" color="ghost" :width="21" link :path="path.ios" target="_blank">
                        <awesome-icon preset="fab" name="apple" />
                        앱스토어(iOS)
                    </st-button>
                </st-divider>
            </div>
            <div class="auth-column">
                <div v-if="visible" class="auth-prev-button">
                    <back-button @click="() => $emit('back')" />
                </div>
                <slot />
            </div>
        </div>
    </auth-background-styled>
</template>
<script>
import styled from "vue-styled-components";

import Logo from "../../../components/Logo";
import BackButton from "../../../components/BackButton";
import Background from "../../../assets/background.png";

const AuthBackgroundStyled = styled.div`
    height: 100vh;
    width: 100vw;

    .auth-top-logo {
        position: absolute;
        top: 0rem;
        width: 100%;
        height: ${props => props.theme.size.header_h};

        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .bg {
        position: absolute;
        background-color: #f6c00c;
        background-image: url(${Background});
        background-size: cover;
        top: 0;
        bottom: 0;
        width: 50vw;
        z-index: -1;
    }

    @media (max-width: 1024px) {
        .bg {
            width: ${props => props.theme.size.half_container_w};
        }
    }

    .auth-row {
        display: flex;
        align-items: center;
        justify-content: center;

        max-width: ${props => props.theme.size.container_w};
        min-width: ${props => props.theme.size.container_w};
        height: inherit;
        margin: 0 auto;
    }

    .auth-column {
        position: relative;
        flex: 1;
        height: inherit;
        display: flex;
        justify-content: center;
        flex-direction: column;

        &.static-effect {
            font-size: 4.2rem;
            color: #ffffff;
        }
    }

    .auth-prev-button {
        position: absolute;
        top: 18rem;
        left: 4.8rem;
        z-index: 5;
    }
`;

export default {
    name: "AuthBackground",
    props: {
        path: Object,
        visible: Boolean
    },
    components: {
        "header-logo": Logo,
        AuthBackgroundStyled,
        BackButton
    }
};
</script>
